import { mutatorAction } from 'satcheljs';
import getStore from '../store';
import { OWAConnectedAccountState } from 'owa-accounts-store';

const setErrorDialogState = mutatorAction(
    'setErrorDialogState',
    (
        hideDialog: boolean,
        failureState: OWAConnectedAccountState = OWAConnectedAccountState.Valid
    ) => {
        const store = getStore();
        store.isDialogHidden = hideDialog;
        store.failureState = failureState;
    }
);

export default setErrorDialogState;
